//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from "vuetify/es5/util/colors";
import VuePlotly from "@statnett/vue-plotly";
import _ from "lodash";

import { CesHttpClient, Continuum } from "../CesHttpClient";
import { densityImageLogColormap } from "../utils/densityImageLog.json";
import { whiteColormap } from "../utils/white.json";
import { plotlyDefaultColorscales, removeTraceByName,  findTraceIndexByName} from "../utils/plotly";

import { mapState } from "vuex";

const clone = require("lodash.clone");
const clonedeep = require("lodash.clonedeep");
const isEqual = require("lodash.isequal");

export default {
  props: {
    plannedLogData: {
      type: Continuum,
      default: null
    },
    curtainGridC: {
      type: Continuum,
      default: null
    },
    imageLog: {
      type: Continuum,
      default: null
    },
    httpClient: {
      type: CesHttpClient,
      default: null
    },
    chartDefinition: {
      type: Object,
      default: {
        charts: [],
        labels: []
      }
    }
  },
  mounted: function() {
    this.initChart();
    this.buildChart();
    this.applyPreferences(); // not working properly because of async this.buildChart()
    this.loadPredefinedColormap();
  },
  data: function() {
    return {
      plotlyRef:{},
      chart: {},
      logTraces: [],
      curtainTraces: [], // curtainTraces is a map, using timestamp (the redrawcounter) as keys.
      imageLogTraces: [], // 
      currentMDpos: 0.0,
      subPlotCount: 0,
      curtainPlotCount: 0,
      imageLogPlotCount: 0,
      logPlotCount: 0,
      logPlotYaxisCount: 0, // logPlotYaxisCount >= logPlotCount, because of the extra grouped logs 
      axisRangeInitialized: false,
      lastAxisRange: {
        xaxisRange: [0, 0],
        yaxisRange: [0, 0]
      },
      cachedCesColormaps: [
        {
          label: "",
          colormap: []
        }
      ],
      densityImageLogColormap: densityImageLogColormap,
      whiteColormap: whiteColormap,
      modeBarButtons:  [
        [
           {
              name: 'Toggle hover text',
              icon: '', // todo: setup a proper icon here
              click: () => {
                // console.log("Toggle hovermode");
                this.chart.layout.hovermode = !this.chart.layout.hovermode;
                }
            },
          "zoom2d",
          "pan2d",
          "zoomIn2d",
          "zoomOut2d",
          // "autoScale2d",  // Disabled because not working properly
          // "resetScale2d",
          "hoverClosestCartesian",
          "hoverCompareCartesian",
          "toImage"
        ]
      ]
    };
  },
  methods: {
    initChart: function() {
      this.curtainTraces = [];
      this.imageLogTraces = [];
      this.axisRangeInitialized = false;
      this.subPlotCount = this.chartDefinition.charts.length;
      this.curtainPlotCount = 1;  // By default: one subplot for curtainGridC
      this.imageLogPlotCount = 1; // By default: one subplot for imageLog
      this.logPlotCount = this.subPlotCount - this.curtainPlotCount - this.imageLogPlotCount;
      // console.log("Init:" + this.logPlotCount);
      this.logPlotYaxisCount = this.selectedLogQuantities.length;
      this.chart = {};
      this.chart = {
        uuid: "345",
        traces: [],
        layout: {
          title: "",
          autosize: true,
          titlefont: {
            color: "black"
          },
          margin: {
            l: 80, // 80
            r: 20, // 80
            t: 60, // 100
            b: 40, // 80
            pad: 0
            // autoexpand: true
          },
          showlegend: true,
          legend: {
            x: 1.05,
            y: 0.05,
            font: {
              color: "black"
            }
          },
          paper_bgcolor: "white",
          plot_bgcolor: "white",
          dragmode: "pan",
          hovermode: false,
          hoverlabel: {
            // TODO: transparent setting not work
            // bgcolor:'rgba(0, 0, 0, 0)', //"transparent",
            // bordercolor: 'rgba(0, 0, 0, 0)', // "transparent",
            // opacity: 1
          },
          xaxis: {
            title: "<b>MD</b>",
            titlefont: {
              color: "black"
            },
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            grid: true,
            zeroline: true,
            showline: true,
            mirror: "allticks",
            gridcolor: colors.grey, // .darken2,
            zerolinecolor: colors.grey, // .darken2,
            zerolinewidth: 2,
            linecolor: "black",
            linewidth: 2,
            side: "top",
            showspikes: true,
            spikethickness: 1,
            spikecolor: "black",
            spikemode: "across"
          },
          yaxis: {  // for curtainGridC
            autorange: "reversed",
            title: {
              font: {
                color: "black"
              },
              text: "Vertical Depth"
            },
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            showgrid: true,
            zeroline: true,
            showline: true,
            mirror: "ticks",
            gridcolor: colors.grey, // .darken2,
            zerolinecolor: colors.grey, // .darken2,
            zerolinewidth: 2,
            linecolor: "black",
            linewidth: 2,
            domain: [0.3, 1.0],
            side: "left",
            showspikes: true,
            spikethickness: 1,
            spikecolor: "black",
            spikemode: "across"
          },
          yaxis2: {  // for imageLog
            autorange: "reversed",
            title: {
              font: {
                color: "black"
              },
              text: "U-R-D-L-U"
            },
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            showgrid: true,
            zeroline: false,
            showline: true,
            mirror: "ticks",
            gridcolor: colors.grey, // .darken2,
            zerolinecolor: colors.grey, // .darken2,
            zerolinewidth: 2,
            linecolor: "black",
            linewidth: 2,
            domain: [0, 0.3],
            side: "left",
            showspikes: true,
            spikethickness: 1,
            spikecolor: "black",
            spikemode: "across"
          },
          yaxis3: {  // for 1D logs
            title: {
              font: {
                color: "black"
              },
              text: ""
            },
            type: 'linear', // All 1D logs using 'linear' plot, except RT_NEW using 'log'
            range: [0, 1], //initial range [ymin, ymax] = [0, 1]
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            showgrid: true,
            zeroline: false,
            showline: true,
            mirror: "ticks",
            gridcolor: colors.grey, // .darken2,
            zerolinecolor: colors.grey, // .darken2,
            linecolor: "black",
            domain: [0, 0.5],
            zerolinewidth: 2,
            linewidth: 2,
            side: "left",
            showspikes: true,
            spikethickness: 1,
            spikecolor: "black",
            spikemode: "across"
          }
        },
        options: {
          useResizeHandler: true,
          responsive: true,
          autosizable: true,
          displaylogo: false,
          scrollZoom: true,
          modeBarButtons: this.modeBarButtons
        }
      };
      // if lastAxisRange cached, restore it
      if (!isEqual(this.lastAxisRange.xaxisRange, [0, 0])) {
        this.chart.layout.xaxis.range = clone(this.lastAxisRange.xaxisRange);
        this.chart.layout.yaxis.range = clone(this.lastAxisRange.yaxisRange);
        this.chart.layout.xaxis.autorange = false;
        this.chart.layout.yaxis.autorange = false;
        this.axisRangeInitialized = true;
      }
    },

    loadPredefinedColormap: function() {
      // console.log("load colormap")
      if(this.densityImageLogColormap) this.cachedCesColormaps.push(this.densityImageLogColormap);
      if(this.whiteColormap) this.cachedCesColormaps.push(this.whiteColormap);
    },

    getDrillbitTrace: function() {
      let drawMDindex = this.currentMDindex + 1;
      const xOrig = this.logPlotData.MD.d;
      const yOrig = this.logPlotData['Z'].d;
      const x = xOrig.slice(0, drawMDindex);
      const y = yOrig.slice(0, drawMDindex);
      if (!x || !y) return {};

      var trace4 = {
        _type: 'wellpathlabel',
        _key: 'drillbitpoint',
        _trim: true,
        _x: clonedeep(xOrig),
        _y: clonedeep(yOrig),
        x: [x[this.currentMDindex]],
        y: [y[this.currentMDindex]],
        type: 'scatter',
        mode: 'markers',
        marker: {
          color: 'green',
          size: 10
        },
        name: 'Drillbit'
      }
      return trace4;
    },

    getTrajBoundaryLines: function(distanceToTraj, isTraceLegendonly, lineColor) {
      let drawMDindex = this.currentMDindex + 1;
      const xOrig = this.logPlotData.MD.d;
      const yOrig = this.logPlotData['Z'].d;
      const x = xOrig.slice(0, drawMDindex);
      const y = yOrig.slice(0, drawMDindex);
      let ytemp = y.map(value => value + distanceToTraj)
      if (!x || !y) return {};

      var trace5 = {
        _type: 'wellpathboundarylines',
        _key: `boundarylines_${distanceToTraj}`,
        _trim: true,
        _x: clonedeep(xOrig),
        _y: clonedeep(yOrig),
        _distanceToTraj: distanceToTraj,
        x: x,
        y: ytemp,
        type: 'scatter',
        line: {
          width: 1,
          shape: "line",
          dash: "dot",
          color: lineColor
        },
        name: ((distanceToTraj > 0) ? '+' : '')  + distanceToTraj + 'm',
        visible: isTraceLegendonly ? 'legendonly' : 'true'
      }
      return trace5;
    },

    logToTrace: function(chart, MNindex) {
      var lw = _.get(chart, "logLineWidth", Array(MNindex + 1).fill(2.0))[
        MNindex
      ];
      var lc = _.get(chart, "logLineColor", Array(MNindex + 1).fill(""))[
        MNindex
      ];
      var setFill = _.get(chart, "logLineFill", Array(MNindex + 1).fill(false))[
        MNindex
      ];
      var drawLong = _.get(
        chart,
        "drawUntil",
        Array(MNindex + 1).fill("DrillBit")
      )[MNindex];
      var logName = _.get(chart, "logLineName", Array(MNindex + 1).fill(""))[
        MNindex
      ];
      var lineType = _.get(chart, "logLineType", Array(MNindex + 1).fill(""))[
        MNindex
      ];
      var MN = _.get(chart, "logMn", ["", ""])[MNindex];
      const q = MN;

      let drawMDindex = this.logPlotData.MD.d.length;
      if (drawLong === "Fwd" && this.currentFwdMDindex) {
        drawMDindex = this.currentFwdMDindex + 1;
      }
      if (drawLong === "DrillBit") {
        drawMDindex = this.currentMDindex + 1;
      }

      const xOrig = this.logPlotData.MD.d;
      let yOrig = this.logPlotData[q].d;

      // If the log property is RT_NEW, using log10 scale.
      if (0 && q == "RT_NEW" && yOrig && Array.isArray(yOrig)) {
        yOrig.forEach(function(element, index) {
          this[index] = Math.log10(element);
        }, yOrig)
      };
      // console.log("logName = " + logName + "; q = " + q);

      var trace3 = {
        _type: 'welllog',
        _key: logName.length > 0 ? logName : q,
        _trim: drawLong === "DrillBit" ? true : false,
        _x: clonedeep(xOrig),
        _y: clonedeep(yOrig),
        _instrumentOffset: this.logPlotData[q].instrumentOffset? this.logPlotData[q].instrumentOffset : 0,
        x: xOrig.slice(0, drawMDindex),
        y: yOrig.slice(0, drawMDindex),
        name: logName.length > 0 ? logName : q,
        line: {
          width: lw,
          shape: "line",
          dash: lineType.length > 0 ? lineType : "solid"
        },
        type: "scatter",
        fill: setFill ? "tozeroy" : "none"
      };
      if (_.has(this.logPlotData[q], "description") && logName.length == 0) {
        if (this.logPlotData[q].description.length > 0) {
          //trace3.name = this.logPlotData[q].description;
        }
      }
      if (lc.length > 0) {
        trace3.line.color = lc;
      }

      if (_.has(this.logPlotData[q], "instrumentOffset") || (this.defaultInstrumentOffset > 0)) {
        var offset = this.defaultInstrumentOffset;  // default offset for all logs
        if (this.logPlotData[q].instrumentOffset > 1e-5) {
          offset = this.logPlotData[q].instrumentOffset; // specific log offset applied if exists
        } 
        // console.log("log property" + q + " offset: " + offset + "meter" + this.logPlotData[q].instrumentOffset);
        
        if (q == "Z") offset = 0; // no offset for Z log

        if (offset > 1e-5) {
          var maxMD = trace3.x[trace3.x.length - 1];
          const MDcutIndex = trace3.x.findIndex(function(el) {
            return el >= maxMD - offset;
          }); // note: findIndex doesn't seem to support starting from the end.
          for (var i = MDcutIndex; i < trace3.x.length; i++) {
            trace3.y[i] = NaN;
          }
        }
      }

      return trace3;
    },

    trimGridDataByMD: function(V, gridMd, MDcut) {
      // This function copies the given grid data (V) and cuts it to a given MD position
      //   The data beyond the cut point is filled with NaN.
      if (MDcut < 0) {
        return V;
      }
      const Vout = [];
      const MDcutIndex = gridMd.findIndex(function(el) {
        return el >= MDcut;
      });
      for (let j = 0; j < V.length; j++) {
        var b = new Float64Array(V[j]);
        if (MDcutIndex >= 0 && MDcutIndex < b.length) {
          b.fill(NaN, MDcutIndex);
        }
        Vout.push(b);
      }
      return Vout;
    },

    curtainToTrace: async function(index, selectedCurtainProperty, selectedCs, curtainXY, curtainProperty, key) {
      let isSecondCurtain = false;
      if (index == 0) {
        isSecondCurtain = false;
      } else {
        isSecondCurtain = true;
      }
      const gridMd = curtainXY['x'];
      if(!gridMd) return;

      const xmin = gridMd[0];
      const xmax = gridMd[gridMd.length - 1] + 500;
      const ymin = this.curtainGridC.getz().first;  // TOCHECK, any issues after using cache data
      const ymax = this.curtainGridC.getz().last;

      const Z = curtainXY.y;

      if (this.axisRangeInitialized == false) {
        this.chart.layout.xaxis.autorange = false;
        this.chart.layout.xaxis.range = [xmin, xmax];

        this.chart.layout.yaxis.autorange = false;
        this.chart.layout.yaxis.range = [ymax, ymin];
        this.axisRangeInitialized = true;
      }

      let cs = await this.validateColormap(selectedCs);
      console.log("after called this.validateColormap()");
      
      // TODO: temp solution for Gina Krog Model only
      let tickvals = [];
      let ticktext = [];
      let zmin = null;
      let zmax = null;
      let reversescale = false; // default value
      let instrumentOffset = 0;
      let showscale = true; // default show color scale

      switch (selectedCurtainProperty) {
        case 'RT_new':
          zmin = 0; 
          zmax = 2.5;
          tickvals = [0, 0.26, 0.5, 0.78, 1, 1.26, 1.5, 1.78, 2,   2.56,2.5];
          // let ticktext:[1, 1.8,  3.2, 6,    10,18,   32,  60,   100, 180, 320],
          ticktext = tickvals.map((x) => Math.round(Math.pow(10,x) * 10)/10); // power 10 and then round to 1 decimal
          instrumentOffset = 16.98;
          break;
        case 'SynRes_1Rx':
          zmin = 0;
          zmax = 2.5;
          tickvals = [0, 0.26, 0.5, 0.78, 1, 1.26, 1.5, 1.78, 2,   2.56,2.5];
          // let ticktext:[1, 1.8,  3.2, 6,    10,18,   32,  60,   100, 180, 320],
          ticktext = tickvals.map((x) => Math.round(Math.pow(10,x) * 10)/10); // power 10 and then round to 1 decimal
          instrumentOffset = 15.78;
          break;
        case 'SynRes_2Rx':
          zmin = 0; 
          zmax = 2.5;
          tickvals = [0, 0.26, 0.5, 0.78, 1, 1.26, 1.5, 1.78, 2,   2.56,2.5];
          // let ticktext:[1, 1.8,  3.2, 6,    10,18,   32,  60,   100, 180, 320],
          ticktext = tickvals.map((x) => Math.round(Math.pow(10,x) * 10)/10); // power 10 and then round to 1 decimal
          instrumentOffset = 21.96;
          break;
        case 'SynRes_3Rx':
          zmin = 0; 
          zmax = 2.5;
          tickvals = [0, 0.26, 0.5, 0.78, 1, 1.26, 1.5, 1.78, 2,   2.56,2.5];
          // let ticktext:[1, 1.8,  3.2, 6,    10,18,   32,  60,   100, 180, 320],
          ticktext = tickvals.map((x) => Math.round(Math.pow(10,x) * 10)/10); // power 10 and then round to 1 decimal
          instrumentOffset = 28.3;
          break;
        case 'Flag':
          zmin = 1;
          zmax = 6;
          tickvals = [1, 2, 3, 4, 5, 6];
          ticktext = tickvals;
          break;
        case 'BG':
          zmin = 1;
          zmax = 1;
          tickvals = [];
          ticktext = tickvals;
          showscale = false;
          break;
        case 'DT':
          zmin = 58;
          zmax = 122;
          tickvals = [60, 80, 100, 120];
          ticktext = tickvals;
          instrumentOffset = 10;
          break;
        case 'RHOB':
          zmin = 1.95;
          zmax = 2.95;
          tickvals = [2, 2.2, 2.4, 2.6, 2.8];
          ticktext = tickvals;
          reversescale = true;
          instrumentOffset = 15.13;
          break;
        case 'GR':
          zmin = 18;
          zmax = 122;
          tickvals = [20, 40, 60, 80, 100, 120];
          ticktext = tickvals;
          instrumentOffset = 5.16;
          break;
        case 'VSH':
          zmin = 0;
          zmax = 1;
          tickvals = [0.2, 0.4, 0.6, 0.8];
          ticktext = tickvals;
          break;
        case 'NPHI':
          zmin = -0.15;
          zmax = 0.45;
          tickvals = [0, 0.2, 0.4, 0.6, 0.8, 1];
          ticktext = tickvals;
          instrumentOffset = 17.22;
          break;
        default:
          console.log()
      }
      const Vx = curtainProperty.propGrid;
      const grid = {
        _type: 'curtaingrid',
        _key: key,
        _trim: isSecondCurtain,
        _isSecondCurtain: isSecondCurtain,
        _instrumentOffset: instrumentOffset,
        _z: clonedeep(Vx),
        x: gridMd,
        y: Z,
        z: this.trimGridDataByMD(Vx, gridMd, isSecondCurtain ? (this.currentMDpos-instrumentOffset) : -1),
        zmin: zmin,
        zmax: zmax,
        type: "heatmap", // todo "heatmapgl" not working with VuePlotly!
        colorscale: cs,
        // showscale: showscale,
        name: selectedCurtainProperty,
        zsmooth: "false", // "false",  // allowed values: best, fast, false
        opacity: isSecondCurtain ? this.preferences.secondCurtainOpacity ? this.preferences.secondCurtainOpacity: 0.85 : 1,
        colorbar: {
          title: '<b>Curtain</b>: ' + selectedCurtainProperty,
          titleside: "right",
          titlefont: {
            color: "black"
          },
          tickfont: {
            color: "black"
          },
          tickvals:tickvals,
          ticktext:ticktext,
          len: 0.3,
          lenmode: "fraction",
          x: 1.01 + index * 0.07,
          yanchor: "top",
          y: 1.0,
          outlinewidth: 2
        },
        reversescale: reversescale
      };

      this.curtainTraces.push(grid);
    },

    fetchCurtainXY: async function(key) {
      await this.httpClient.downloadContinuumPropertyBinary(this.curtainGridC, "Z");
      await this.httpClient.convertCurtainToMD(this.curtainGridC);

      const gridMd = this.curtainGridC.getMD();  // todo: how about failed to fetch MD from the server? validate MD
      const Z = this.curtainGridC.getData("Z"); // Z.data

      const curtainXYCache = {
        key: key,
        obj: {
          x: gridMd,
          y: Z,
        }
      };
      await this.localCache(curtainXYCache);
    },
    fetchCurtainProperty: async function(key, selectedCurtainProperty) {
      await this.httpClient.downloadContinuumPropertyBinaryZip(this.curtainGridC, selectedCurtainProperty);
      let tempGrid = this.curtainGridC.getData(selectedCurtainProperty); // just copy the Object reference

      // If the property is RT_new, using log10 scale.
      // !!! Assume Vx should be in the format of Array[Float64Array Float64Array]
      // The modification here will write back to this.curtainGridC["_data"]["RT_new"])
      const resistivityProps = ["RT_new", "SynRes_1Rx", "SynRes_2Rx", "SynRes_3Rx"];
      if(( resistivityProps.includes(selectedCurtainProperty)) && tempGrid && Array.isArray(tempGrid)) {
        tempGrid.forEach(function(elementObj, index) {  // elementObj is supposed be a Float64Array object.
          if(elementObj) {
            for (const [key, value] of Object.entries(elementObj)) {
            elementObj[key] = Math.log10(value);
          }}
        this[index] = elementObj;
      }, tempGrid)}

      const curtainPropertyCache = {
        key: key,
        obj: {
          propGrid: tempGrid,
        }
      };
      await this.localCache(curtainPropertyCache);
    },

    fetchCurtain: async function(selectedCurtainProperties, selectedCSs) {
      for (let i = 0; i < selectedCurtainProperties.length; i++) {
        const selectedCurtainProperty = selectedCurtainProperties[i];
        const selectedCs = selectedCSs[i];

        if (selectedCurtainProperty.length < 1) {
          continue;
        }
        // Get jobId (or scenario id) from requested pointers
        // One example of pointer: /1.1.1 Perturbable variable/Curtain.CurtainGridC/SynRes_2Rx/job-0002
        const jobId = this.lastRequestedPointers[0].slice(this.lastRequestedPointers[0].indexOf('job'))
        const keyXY = `${this.curtainGridC._tag}_${jobId}_XY`;
        const keyProperty = `${this.curtainGridC._tag}_${jobId}_${selectedCurtainProperty}`;

        this.updateProgress(1);
        try {
            const keys = await this.$vlf.keys();
            // console.log(JSON.stringify(keys, null, 2))

            if(!keys.includes(keyXY)) await this.fetchCurtainXY(keyXY);
            if(!keys.includes(keyProperty)) await this.fetchCurtainProperty(keyProperty, selectedCurtainProperty);
        } catch (err) {
          console.log('Failed to fetch curtain data.')
          console.log(err);
        }
        this.updateProgress(-1);

        const curtainXY = await this.$vlf.getItem(keyXY);
        const curtainProperty = await this.$vlf.getItem(keyProperty);

        if(curtainXY && curtainProperty) await this.curtainToTrace(i, selectedCurtainProperty, selectedCs, curtainXY, curtainProperty, keyProperty);
      }
    },

    fetchImageLog: async function(imageLog, cProp, key) {
      if (!imageLog) return;

        if(this.isPrintConsole) console.log("Fetch ImageLog ! " + "cProp = " + JSON.stringify(cProp));
        try {
          await this.httpClient.downloadContinuumPropertyBinary(imageLog, "X"); // X =[0, ..., nb of sectors]
          await this.httpClient.downloadContinuumPropertyBinary(imageLog, "Z"); // Currently in GSTS server, "MD" is stored at "Z"
          await this.httpClient.downloadContinuumPropertyBinaryZip(imageLog, cProp[0]); // 2D GRID, [[], ...]
          if (!imageLog.hasData(cProp[0])) console.log("Missing property: " + cProp[0]);
          if (!imageLog.hasData("X")) console.log("Missing X");
          if (!imageLog.hasData("Z")) console.log("Missing Z");

          const gridMd = imageLog.getData("Z");  // Z is MD
          const y = imageLog.getData("X");  // X =[0, ..., nb of sectors]
          const z = imageLog.getData(cProp[0]);
          // Re-formating the imagelog data took 100 milliseconds
          let normalz = z.map(colArray => Array.from(colArray)); // convert Float64Array to normal array
          let zflip =  normalz[0].map((_, i) => normalz.map(row => row[i])); // tranpose 2D array

          const imagelogCache = {
            key: key,
            obj: {
              x: gridMd,
              y: y,
              z: zflip
            }
          };

          await this.localCache(imagelogCache);

        } catch (e) {
            console.log("Failed to download the property of imageLog, " + e.message)
        }
    },
    addImageLogToTrace: async function(imagelogObj, cProp, cmapProp, key) {
      let cs = await this.validateColormap(cmapProp[0]); // took 4 milliseconds
      const imageLogInstrumentOffset = 15.13;

      // For density image log
      let zmin = 1.95;
      let zmax = 2.95;
      let tickvals = [2, 2.2, 2.4, 2.6, 2.8];
      let ticktext = tickvals;
      let trace = {
        _type: 'imageloggrid',
        _key: key,
        _trim: this.trimImageLog,
        _z: clonedeep(imagelogObj.z),
        _instrumentOffset: imageLogInstrumentOffset,
        x: imagelogObj.x,
        y: imagelogObj.y,
        yaxis: "y2",
        // z: zflip,
        z: this.trimGridDataByMD(imagelogObj.z, imagelogObj.x, this.trimImageLog ? (this.currentMDpos - imageLogInstrumentOffset) : -1),
        zmin: zmin,
        zmax: zmax,
        name: "ImageLog",
        opacity: 1,
        type: "heatmap",
        colorscale: cs,
        colorbar: {
          title: '<b>Image Log</b> <br>' + cProp[0],
          titleside: "right",
          titlefont: {
            color: "black"
          },
          tickvals: tickvals,
          ticktext: ticktext,
          tickfont: {
            color: "black"
          },
          len: 0.2,
          lenmode: "fraction",
          x: 1.02,
          yanchor: "top",
          y: 0.6,
          outlinewidth: 2
        },
        reversescale: true
      };

      this.imageLogTraces.push(trace);
    },

    localCache: async function(cacheObj) {
      try {
        const keys = await this.$vlf.keys();

        // Assume, the continuum with the same continuum id will not change during the run-time.
        if (keys.includes(cacheObj.key)) {
          } else {
            const res = await this.$vlf.setItem(cacheObj.key, cacheObj.obj);
            console.log('Cache success for key: ' + cacheObj.key);
          }
        } catch (err) {
          console.log('Cache failure for key: ' + cacheObj.key);
          console.log(err)
        }
    },

    buildImageLog: async function(imageLog) {
      this.updateProgress(1);
      this.imageLogTraces = [];

      for (let i = 0; i < this.subPlotCount; i++) {
        const chart = this.chartDefinition.charts[i];
        let cProp = _.get(chart, "imageLogProperty", [""]);
        let cmapProp = _.get(chart, "imageLogColorMap", [""]);

        if (!Array.isArray(cProp)) {
          cProp = [cProp];
        }
        if (!Array.isArray(cmapProp)) {
          cmapProp = [cmapProp];
        }

        if (cProp[0].length > 0) {
          try {
            const key = `imagelog_${imageLog._id}_${cProp[0]}`;

            const keys = await this.$vlf.keys();
            // console.log(JSON.stringify(keys, null, 2))
            if (keys.includes(key)) {
              console.log("Skip to fetch image log data. Use cached data.")
            } else {
              console.log('Start to fetch imagelog data.')
              await this.fetchImageLog(imageLog, cProp, key);
              console.log('Finish the fetch of imagelog data.')
            }

            const imagelogObj = await this.$vlf.getItem(key);

            await this.addImageLogToTrace(imagelogObj, cProp, cmapProp, key);

          } catch (err) {
            console.log(err)
          }
        }
      }

      this.updateProgress(-1);
    },

    createVirtualLineForImageLog: function() {
      // Draw a virtual line to quickly initiating the imagelog subplot, to avoid the white gap
      // Will be removed if later we overly some 1D logs on imagelog subplot
      var virtualLineTrace = {
        _type: 'placeholder',
        _key: 'imagelog_placeholder',
        _trim: false,
        x: [5000, 5000],
        y: [0, 0],
        mode: 'lines',
        yaxis: 'y2',  // yaxis2 - image log
        opacity: 0.2,
        showlegend: false,
      }
      if(this.diameterImageLog) this.chart.layout.yaxis2.range = [0, Math.PI * this.diameterImageLog]; // No.sectors * Aperture, new format [0, PI * Diameter]
      this.chart.layout.yaxis2.autorange = false;
      this.logTraces.push(virtualLineTrace);
    },

    buildChart: async function() {
      this.updateProgress(1);

      this.buildLogs();

      if (this.showImageLog && this.imageLog && this.imageLog._type != "EMPTY") {
        this.createVirtualLineForImageLog();
      }
      this.combineTraces();

      await this.buildCurtains();  // usually took 2 seconds for one curtain, 3 seconds for 2 curtains

      if (this.showImageLog && this.imageLog && this.imageLog._type != "EMPTY") {
        console.log("buildImageLog() called by builcChart()");
        await this.buildImageLog(this.imageLog); // usually took 3 seconds for one image log
      }
      this.combineTraces();

      this.updateProgress(-1);
    },

    setYaxises: function() {
      // set the domin size for subplots & copy default yaxis setting
      if(this.showImageLog && this.imageLog && this.imageLog._type != "EMPTY") {
        var imgLogH = 0.13;
      } else {
        var imgLogH = 0;
      }
      let logH = 0;  // the total height of 1-d logs
      switch (this.logPlotCount) {
        case 0:
          logH = 0;
          break;
        case 1:
          logH = 0.2;
          break;
        case 2:
          logH = 0.3;
          break;
        default:
          logH = 0.4;
          break;
      }
      let curtainH = 1 - imgLogH - logH;

      this.chart.layout.yaxis.domain = [1-curtainH, 1];  // curtain
      this.chart.layout.yaxis2.domain = [1-curtainH-imgLogH, 1-curtainH]; // image log
      
      if (this.logPlotCount > 0) {
        const hh = logH / this.logPlotCount;
        for (var i = 0; i < this.logPlotCount; i++) {
          if (i > 0) {
            this.chart.layout["yaxis" + (i + 3)] = clonedeep(
              this.chart.layout.yaxis3
            );
          }
          this.chart.layout["yaxis" + (i + 3)].domain = [
            Math.min(i * hh, 1.0),
            Math.min((i + 1) * hh, 1.0)
          ];
        }
      }

      // add additional yaxises for grouped logs
      if (this.logPlotYaxisCount > this.logPlotCount) {
        for (let k = 0; k < this.logPlotYaxisCount - this.logPlotCount; k++) {
          this.chart.layout["yaxis" + (k + 3 + this.logPlotCount)] = clonedeep(
            this.chart.layout.yaxis3
          );
        }
      }
    },

    set1DLogRange: function(logPropertyName) {
       // TODO: temp solution for Gina Krog Model only
      let min = null;
      let max = null;

      switch (logPropertyName) {
        case 'RT_new':
        case 'RT_NEW':
        case 'SynRes_1Rx':
        case 'SynRes_2Rx':
        case 'SynRes_3Rx':
          min = 0; 
          max = 3.4;
          break;
        case 'Flag':
        case 'FLAG':
          min = 1;
          max = 6.5;
          break;
        case 'DT':
          min = 58;
          max = 122;
          break;
        case 'RHOB':
          min = 1.95;
          max = 2.95;
          break;
        case 'GR':
          min = 0;
          max = 122;
          break;
        case 'VSH':
          min = 0;
          max = 1;
          break;
        case 'NPHI':
          min = 0.45;
          max = -0.15;
          break;
        default:
          min = 0;
          max = 1;
      }

      return [min, max];
    },

    buildLogs: function() {
      if (!this.logPlotData) {
        return;
      }
      this.updateProgress(1);

      this.logTraces = [];

      this.setYaxises();

      let count = 0;
      let qqCount = 0;
      for (let j = 0; j < this.subPlotCount; j++) {
        const chart = this.chartDefinition.charts[j];

        let cProp = _.get(chart, "curtainProperty", [""]);
        if (!Array.isArray(cProp)) {
          cProp = [cProp];
        }
        if (cProp[0].length > 0) {
          continue;
        }

        const MNlist = _.get(chart, "logMn", [""]);

        const yaxes = {};
        for (let k = 0; k < MNlist.length; k++) {
          const q = _.get(chart, "logMn", Array(k + 1).fill(""))[k];
          if (q.length < 1) {
            continue;
          }
          const setSide = _.get(chart, "logSide", Array(k + 1).fill("left"))[k];

          let yaxisRange = this.set1DLogRange(q);
          console.log("The y axis range of " + q + ": = " + yaxisRange);

          const trace0 = this.logToTrace(chart, k);
          if (k == 0) {
            trace0.yaxis = "y" + (count + 3);
            yaxes[q] = "y" + (count + 3);
            if (
              setSide.length > 0 &&
              this.chart.layout["yaxis" + (count + 3)].overlaying != undefined
            ) {
              this.chart.layout["yaxis" + (count + 3)].side = setSide;
            }
            this.chart.layout["yaxis" + (count + 3)].title.text = q; //trace0.name; //q
            if(yaxisRange)this.chart.layout["yaxis" + (count+3)].range = yaxisRange;
            // set logarithmic Axes for 'RT_NEW'
            if(q == "RT_NEW")this.chart.layout["yaxis" + (count + 3)].type = 'log';
            count = count + 1;
          }

          if (k > 0 && q.length > 0) {
            // deal with grouped logs, qq
            trace0.yaxis = "y" + (qqCount + 3 + this.logPlotCount);
            if (setSide.length > 0) {
              this.chart.layout[
                "yaxis" + (qqCount + 3 + this.logPlotCount)
              ].side = setSide;
            }
            this.chart.layout[
              "yaxis" + (qqCount + 3 + this.logPlotCount)
            ].title.text = q; //trace0.name; //q;
            if(yaxisRange)this.chart.layout["yaxis" + (qqCount + 3 + this.logPlotCount)].range = yaxisRange;

            const logOverLay = _.get(
              chart,
              "logOverLaying",
              Array(k + 1).fill("")
            )[k];
            this.chart.layout[
              "yaxis" + (qqCount + 3 + this.logPlotCount)
            ].overlaying = _.get(yaxes, logOverLay, "");

            // hide gridlines for all but the first subplot.
            this.chart.layout[
              "yaxis" + (qqCount + 3 + this.logPlotCount)
            ].gridwidth = 0.0;
            this.chart.layout[
              "yaxis" + (qqCount + 3 + this.logPlotCount)
            ].gridcolor = "white";

            qqCount = qqCount + 1;
          }

          this.logTraces.push(trace0);
        }
      }

      // build the logs inside the curtain subplot
      const x = this.logPlotData.X.d;
      const y = this.logPlotData.Y.d;
      const z = this.logPlotData.Z.d;
      const md = this.logPlotData.MD.d;

      for (var i = 0; i < this.subPlotCount; i++) {
        const chart = this.chartDefinition.charts[i];

        let cProp = _.get(chart, "curtainProperty", [""]);
        if (!Array.isArray(cProp)) {
          cProp = [cProp];
        }
        if (cProp[0].length == 0) {
          continue;
        }

        const MNlist = _.get(chart, "logMn", ["", ""]);
        for (let j = 0; j < MNlist.length; j++) {
          var trace3 = this.logToTrace(chart, j);
          this.logTraces.push(trace3);
        }

        // Plot drillbit position & the virtual line up/down to trajectory
        const logLineName = _.get(chart, "logLineName", ["", ""]);
        if(logLineName.includes("Drilled Path")) {
          // plot drill head
          var trace4 = this.getDrillbitTrace();
          this.logTraces.push(trace4);
        }

        // plot the virtual line that 1RxTx distance up and down to the trajectory
        if(logLineName.includes("Drilled Path") && (cProp.includes("SynRes_3Rx") || cProp.includes("SynRes_2Rx") || cProp.includes("SynRes_1Rx"))) {
          // To allow helplines for 1r, 2r, 3r to be displayed simultaneously.
          // 1Rx = 12.6 meters
          // 2Rx = 25 meters
          // 3Rx = 37 meters
          // const helplines = [12.6, 25, 37];
          const helplines = [
            {
              name: 'SynRes_1Rx',
              distance: 12.6,
              isTraceLegendonly: this.selectedCurtainProperties.includes('SynRes_1Rx') ? false : true,
              lineColor: 'grey',
            },
            {
              name: 'SynRes_2Rx',
              distance: 25,
              isTraceLegendonly: this.selectedCurtainProperties.includes('SynRes_2Rx') ? false : true,
              lineColor: 'grey',
            },
            {
              name: 'SynRes_3Rx',
              distance: 37,
              isTraceLegendonly: this.selectedCurtainProperties.includes('SynRes_3Rx') ? false : true,
              lineColor: 'black',
            },
          ]
          helplines.forEach( (helpline) => {
            this.logTraces.push(this.getTrajBoundaryLines(helpline.distance, helpline.isTraceLegendonly, helpline.lineColor));
            this.logTraces.push(this.getTrajBoundaryLines(-helpline.distance, helpline.isTraceLegendonly, helpline.lineColor));
          })
        }
      }

      if (_.has(this.chartDefinition, "labels")) {
        for (let i = 0; i < this.chartDefinition.labels.length; i++) {
          const label = this.chartDefinition.labels[i];

          for (let j = 0; j < label.markerText.length; j++) {
            const mdpos = label.posMD[j];
            const zpos = label.posZ[j];
            if (isNaN(zpos)) {
              const MDIndex = md.findIndex(function(el) {
                return el >= mdpos - 1e-5;
              });
              label.posZ[j] = z[MDIndex];
            }
          }

          var labelTrace = {
            _type: 'textlabel',
            _key: label.markerText,
            _trim: false,
            x: clone(label.posMD),
            y: clone(label.posZ),
            mode: "markers",
            name: label.markerName,
            text: clone(label.markerText),
            textposition: _.get(label, "textPosition", "top"),
            type: "scatter",
            marker: {
              color: "rgba(12, 12, 12, 0.5)",
              size: 7,
              line: {
                color: "rgb(12, 12, 12)",
                width: 1.5
              }
            }
          };
          this.logTraces.push(labelTrace);
        }

        var newAnnotations = [];
        for (let i = 0; i < this.chartDefinition.labels.length; i++) {
          const label = this.chartDefinition.labels[i];
          for (let j = 0; j < label.markerText.length; j++) {
            const a = {
              _type: 'textlabel',
              _key: label.markerText[j],
              _trim: false,
              x: label.posMD[j],
              y: label.posZ[j],
              xref: "x",
              yref: "y",
              text: label.markerText[j],
              showarrow: false,
              textangle: "-65",
              xanchor: "left",
              yanchor: "bottom",
              xshift: -5
            };
            newAnnotations.push(a);
          }
        }
        this.chart.layout.annotations = newAnnotations;
      }

      this.updateProgress(-1);
    },

    buildCurtains: async function() {
      this.updateProgress(1);
      this.curtainTraces = [];

      for (let i = 0; i < this.subPlotCount; i++) {
        const chart = this.chartDefinition.charts[i];
        let cProp = _.get(chart, "curtainProperty", [""]);
        let cmapProp = _.get(chart, "curtainColorMap", [""]);

        if (!Array.isArray(cProp)) {
          cProp = [cProp];
        }
        if (!Array.isArray(cmapProp)) {
          cmapProp = [cmapProp];
        }

        if (cProp[0].length > 0) {
          await this.fetchCurtain(cProp, cmapProp);
        }
      }
      this.updateProgress(-1);
    },

    combineTraces: function() {
      // clean the existing traces before push
      this.chart.traces = [];
      console.log("Traces recombined at " + new Date().getTime());
      this.chart.layout.datarevision = new Date().getTime();
      this.chart.traces = this.logTraces.concat(this.curtainTraces, this.imageLogTraces);

      // this.applyPreferences(); // No need to applyPreferences since no data loaded for planned well
    },

    updateCurrentMDpos: function() {
      const sliced = this.logPlotData.MD.d.slice(
        this.currentMDindex,
        this.currentMDindex + 1
      );
      this.currentMDpos = sliced[0];
    },

    validateColormap: async function(selectedCs) {
      // default ces colorscales from cesapi
      const cesDefaultColorscales = this.httpClient.getCesDefaultColormaps();
      const cachedColormaps = this.cachedCesColormaps.map(obj => obj.label);

      if (plotlyDefaultColorscales.includes(selectedCs)) {
        return selectedCs;
      } else if (cesDefaultColorscales.includes(selectedCs) || cachedColormaps.includes(selectedCs)) {
        //if(this.isPrintConsole) console.log("Using cesapi default colormap: " + selectedCs);
        if (this.cachedCesColormaps.find(x => x.label === selectedCs)) {
          //console.log("Colormap " + selectedCs + " has been cached before!");
          let colorMap = this.cachedCesColormaps.find(x => x.label === selectedCs);
          return colorMap.colormap;
        } else {
          console.log("Download the ces colormap " + selectedCs + " from server.");
          const cs = await this.httpClient.getColormapByTag(selectedCs);
          this.cacheCesColormap(selectedCs, cs);
          return cs;
        }
      } else {
        //console.log(selectedCs + " not match with any default colormaps. Using plotly default colormap Greys");
        return "Greys";
      }
    },

    updateProgress: function(progress) {
      this.$store.commit("preferences/updateProgress", progress);
    },

    relayoutCallback: function(eventdata){
      var x =  [eventdata['xaxis.range[0]'], eventdata['xaxis.range[1]']];
      var y =  [eventdata['yaxis.range[0]'], eventdata['yaxis.range[1]']];

      if(x[0] != undefined && x[1] != undefined){
        this.lastAxisRange.xaxisRange = x; 
      }
      
      if(y[0] != undefined && y[1] != undefined){
        this.lastAxisRange.yaxisRange = y;  
      }
    },

    cacheCesColormap: function(selectedCs, cs) {
      // if downloaded one ces colormap from server, cache it in the local pool
      if (this.cachedCesColormaps.find(x => x.label === selectedCs)) {
        console.log("Colormap " + selectedCs + " is already cached!");
        return;
      }

      let colorMap = { label: selectedCs, colormap: cs };
      this.cachedCesColormaps.push(colorMap);
    },

    setOpacity: function(opacity) {
      for (let i = 0; i < this.chart.traces.length; i++) {
        if (
          this.chart.traces[i].hasOwnProperty("opacity") &&
          this.chart.traces[i].hasOwnProperty("_isSecondCurtain")
        ) {
          if (this.chart.traces[i]._isSecondCurtain == true) {
            this.chart.traces[i].opacity = opacity;
          }
        }
      }
    },
    addPlannedWell: function() {
      if (!this.plannedLogData)
        return;
      if (
        !this.plannedLogData ||
        !this.plannedLogData.hasData("MD") ||
        !this.plannedLogData.hasData("TVDMSL") //Is TVDMSL the correct Vertical Depth?
      )
        return;
      const x = this.plannedLogData.getData("MD");
      const y = this.plannedLogData.getData("TVDMSL");
      let trace = {
        _type: 'wellpath',
        _key: 'plannedwell',
        _trim: false,
        x: x,
        y: y,
        name: "Planned Well",
        opacity: 0.5,
        line: {
          width: 2,
          shape: "line",
          color: "yellow"
        }
      };

      this.chart.traces.push(trace);
    },
    applyPreferences: function() {
      const prefs = this.preferences;

      this.setOpacity(prefs.secondCurtainOpacity);

      if (
        prefs.showPlannedWell && findTraceIndexByName(this.chart.traces, "Planned Well") == -1
      ) {
        this.addPlannedWell();
      }
      if (
        !prefs.showPlannedWell && findTraceIndexByName(this.chart.traces, "Planned Well") != -1
      ) {
        removeTraceByName(this.chart.traces, "Planned Well");
      }
    },
    updateMsgToUser: function(msg) {
      // msg = { msg: "Hi, CES GSTS user!", type: "info" }
      this.$store.commit("messages/updateMsgToUser", msg);
    },
    trimChartByMd: function() {
      console.log(this.currentMDpos)
      const traces = this.chart.traces;
      traces.forEach((trace, index, traces) => {
        if(trace.hasOwnProperty('_trim') && trace._trim) {
          // For 2D grids like curtaingrid & imageloggrid
          if(trace.hasOwnProperty('_type') && (trace._type == 'curtaingrid' || trace._type == 'imageloggrid')) {
            traces[index].z = this.trimGridDataByMD(trace._z, trace.x, this.currentMDpos- trace._instrumentOffset);
          }
          // For 1D logs like wellpath without _instrumentOffset parameter
          if(trace.hasOwnProperty('_type') && (trace._type == 'wellpath')) {
            traces[index].x = trace._x.slice(0, this.currentMDindex + 1);
            traces[index].y = trace._y.slice(0, this.currentMDindex + 1);
          }
          // For 1D logs like well log with _instrumentOffset parameter
          if(trace.hasOwnProperty('_type') && (trace._type == 'welllog')) {
            if(trace.hasOwnProperty('_instrumentOffset') && (trace._instrumentOffset > 0 )) {
              const MDcutIndex = trace._x.findIndex((el) => {
                return el >= this.currentMDpos - trace._instrumentOffset;
              }); // note: findIndex doesn't seem to support starting from the end.
              traces[index].x = trace._x.slice(0, MDcutIndex + 1);
              traces[index].y = trace._y.slice(0, MDcutIndex + 1);
            } else {
              traces[index].x = trace._x.slice(0, this.currentMDindex + 1);
              traces[index].y = trace._y.slice(0, this.currentMDindex + 1);
            }
          }
          // For 1D support virtual lines like wellpathboundarylines
          if(trace.hasOwnProperty('_type') && (trace._type == 'wellpathboundarylines')) {
            const y = trace._y.slice(0, this.currentMDindex + 1);
            traces[index].x = trace._x.slice(0, this.currentMDindex + 1);
            traces[index].y = y.map(value => value + trace._distanceToTraj);
          }
          // For labels like drillbit
          if(trace.hasOwnProperty('_type') && (trace._type == 'wellpathlabel')) {
            const x = trace._x;
            const y = trace._y;
            traces[index].x = [x[this.currentMDindex]];
            traces[index].y = [y[this.currentMDindex]];
          }
        }
      })
      // this.chart.layout.datarevision = new Date().getTime();
    }
  },
  computed: {
    preferences() {
      console.log("preferences is computed.")
      let prefs_merged = {};
      prefs_merged = Object.assign(
        {},
        this.$store.state.preferences.global,
        this.$store.state.preferences.logsView
      );
      return prefs_merged; // store preferences using Vuex
    },
    ...mapState({
      isPrintConsole: state => state.preferences.isPrintConsole,
      logPlotData: state => state.drilling.logPlotData,
      currentMDindex: state => state.drilling.currentMDindex,
      currentFwdMDindex: state => state.drilling.currentFwdMDindex,
      isDrillStep: state => state.drilling.isDrillStep,
      defaultInstrumentOffset: state => state.drilling.defaultInstrumentOffset,
      selectedCurtainProperties: state => state.curtains.selectedCurtainProperties,
      selectedLogQuantities: state => state.logs.selectedLogQuantities,
      showImageLog: state => state.preferences.showImageLog,
      trimImageLog: state => state.curtains.trimImageLog,
      diameterImageLog: state => state.curtains.diameterImageLog,
      lastRequestedPointers: state => state.drilling.lastRequestedPointers,
    })
  },
  watch: {
    currentMDindex: async function() {
      if(this.isPrintConsole) console.log("Is in DrillStep Status: " + this.isDrillStep);
      if (this.isDrillStep) {
        this.updateCurrentMDpos();
        if(this.isPrintConsole) console.log("buildChart() triggered by currentMDindex change");
        // await this.buildChart();
        this.trimChartByMd()
        this.$store.commit("drilling/updateIsDrillStep", false);
      }
    },
    chartDefinition: {
      handler: async function(val, oldVal) {
        if(this.isPrintConsole) console.log("buildChart triggered by chartDefinition change");
        this.updateCurrentMDpos();
        this.initChart();
        await this.buildChart();
      },
      deep: true
    },
    preferences: {
      handler: function() {
        this.applyPreferences();
      },
      deep: true
    },
  },
  components: {
    VuePlotly
  }
};
